import React, { Component } from "react";
import { Helmet } from "react-helmet";
import moment from "moment";

import Api from "../../../../lib/componentApi";
import Loading from "../../../../components/Common/Loading";

class PointsList extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      limit: 10,
      index: 0,
      lastPoints: [],
      hasMore: false,
      loading: true
    };
  }
  componentDidMount() {
    this.getPoints();
  }
  getPoints = () => {
    const { limit, index } = this.state;
    Api.post(
      "/api/user/points",
      {
        limit,
        index,
        startDate: moment
          .utc(new Date("2017-01-01"))
          .local()
          .format("YYYY-MM-DD"),
        endDate: moment
          .utc(new Date())
          .local()
          .format("YYYY-MM-DD")
      },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "points-code");
        } else {
          if (limit <= response.length) {
            this.setState({
              hasMore: true,
              lastPoints: [...this.state.lastPoints, ...response]
            });
          } else {
            this.setState({
              hasMore: false,
              lastPoints: [...this.state.lastPoints, ...response]
            });
          }
        }
        this.setState({ loading: false });
      }
    );
  };
  handleCloseInformation = () => {
    this.setState({ pointsInformation: false });
  };
  getPointsBody = pointItem => {
    let title, body;
    const { promoCode, refCode, restaurantName, orderUid } = pointItem || null;
    switch (pointItem.sourceType) {
      case "FRIEND_REF":
        title = `#${refCode}`;
        body = "Referral Bonus";
        break;
      case "REF":
        title = `#${refCode}`;
        body = "Referrer Bonus";
        break;
      case "ORDER":
        title = `#${orderUid}`;
        body = restaurantName;
        break;
      case "STARTING":
        title = ``;
        body = "Sign Up Bonus";
        break;
      case "PROMO":
        title = `#${promoCode}`;
        body = "Promotion";
        break;
      case "LOCALE_GOAL":
        title = ``;
        body = `Saving Bonus`;
        break;
      case "FIRST_ORDER":
        title = ``;
        body = `First Order Bonus`;
        break;
      case "ORDER_REVIEW":
        title = ``;
        body = `Order Review Bonus`;
        break;
      case "ORDER_COMPLETED":
        title = ``;
        body = `Collection Bonus`;
        break;
    }
    return { title, body };
  };
  getPointValues = pointItem => {
    let pointText;
    const { points } = pointItem;
    switch (pointItem.type) {
      case "INCREASE":
        pointText = `+${points}`;
        break;
      case "TAKEBACK":
        pointText = `-${points}`;
        break;
      case "PAYBACK":
        pointText = `+${points}`;
        break;
      case "DECREASE":
        pointText = `-${points}`;
        break;
    }
    return { pointText };
  };
  handleClickItem = (e, sourceType, orderUid) => {
    if (sourceType === "ORDER") {
      let href = `/profile?orders#${orderUid}`;
      if (href) {
        window.location.href = href;
      }
    } else {
      e.preventDefault();
    }
  };
  getMore = () => {
    const { index, limit } = this.state;
    this.setState(
      {
        index: index + limit
      },
      () => {
        this.getPoints();
      }
    );
  };
  render() {
    const { pointsWithExpires } = this.props || null;
    const { lastPoints, hasMore, loading } = this.state;
    return (
      <div className="profile-desktop mt-0">
        <Helmet>
          <title>eCoins</title>
          <meta property="og:title" content="Points" />
        </Helmet>
        <div className="points-page">
          <div>
            <div className="row">
              {(pointsWithExpires && pointsWithExpires.length && (
                <React.Fragment>
                  <div className="white-bg mt-10px expire">
                    <strong>eCoins to expire</strong>
                    <ul>
                      {pointsWithExpires.map((expires, i) => (
                        <li key={i}>
                          <p>{expires.points} eCoins</p>
                          <p>
                            {moment(new Date(expires.expiresAt)).format(
                              "DD/MM/YYYY"
                            )}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </React.Fragment>
              )) || <noscript />}
            </div>
            {(lastPoints && lastPoints.length && (
              <div>
                <div className="white-bg mt-10px padding-box list">
                  <h5>Latest transactions</h5>
                  <ul>
                    {lastPoints.map((pointItem, i) => {
                      const { body, title } = this.getPointsBody(pointItem);
                      const { pointText } = this.getPointValues(pointItem);
                      return (
                        <li
                          key={i}
                          className={`d-flex justify-content-between align-items-center ${(pointItem.sourceType ===
                            "ORDER" &&
                            "cursor-pointer") ||
                            ""}`}
                          onClick={e =>
                            this.handleClickItem(
                              e,
                              pointItem.sourceType,
                              pointItem.orderUid
                            )
                          }
                        >
                          <div>
                            <p className="date">
                              {moment(pointItem.createdAt).format("DD.MM.YYYY")}
                            </p>
                            <p>
                              <label className="small-label">{title}</label>
                              <span className="bold">{body}</span>
                            </p>
                          </div>
                          <p>{pointText} eCoins</p>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                {(hasMore && (
                  <a
                    href="javascript: void(0)"
                    className="more-btn"
                    onClick={this.getMore}
                  >
                    See More
                  </a>
                )) || <noscript />}
              </div>
            )) ||
              (loading && <Loading />) || (
                <div className="d-flex align-items-center justify-content-center wfull">
                  <div className="white-bg mt-10px empty-body wfull">
                    <div className="empty-img">
                      <img src="/png/no-order.png" alt="" />
                    </div>
                    <p>No history yet...</p>
                  </div>
                </div>
              )}
          </div>
          {/* )} */}
        </div>
      </div>
    );
  }
}

export default PointsList;
